// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9855c2eb","453":"198dc608","455":"3a6cdf56"}[chunkId] + ".chunk.js";
};